var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-more-container",attrs:{"data-v-c9bcc182":""}},[_c('div',{staticStyle:{"color":"rgb(170, 174, 184)","font-size":"0.12rem"},attrs:{"data-v-c9bcc182":""}},[_vm._v("\n      "+_vm._s(_vm.sportTableLang['SPORT_TABLE.END'])+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17bf095a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/score/vue/apps/core/scrollEnd.vue
// module id = 301
// module chunks = 0